module.exports = __webpack_public_path__ + "assets/img/reproduction-img2-1f3f07ea.jpg";